<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import Input from '$shared/atoms/Input/Input.svelte';

  interface Props {
    icon?: string;
    label?: string;
    name?: string;
    value?: string | number;
    hasIconDisable?: boolean;
    required?: boolean;
    onclickIcon?: () => void;
  }

  let {
    icon = 'icon-edit-custom',
    label = '',
    name = '',
    value = '',
    hasIconDisable = false,
    required = false,
    onclickIcon
  }: Props = $props();

  const onClickIcon = () => {
    onclickIcon?.();
  };
</script>

<div class="comp-disabled-input">
  <Input disabled {required} {name} {value} {label}>
    {#snippet actions()}
        <div  class="icon">
        <Icon
          name={icon}
          value={icon}
          disabled={hasIconDisable}
          type={IconType.Button}
          onclick={onClickIcon}
        />
      </div>
      {/snippet}
  </Input>
</div>

<style>
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }
</style>
